import { useQuery } from "@tanstack/react-query";
import fetchToBackend, { buildQuery } from "@/utils/fetchToBackend";
import { teamKeys } from "@/lib/query-keys";
import type { MonthlyStat } from "@/types/domain";

/**
 * El ritmo mes a mes de la empresa. Se pide al backend y no se calcula sobre el
 * listado: con el pipeline paginado, contar en el cliente daría el número de la
 * página en vez del del mes.
 */
export function useMonthlyStats(scope: "team" | "mine", months = 6) {
  return useQuery({
    queryKey: teamKeys.monthlyStats(scope, months),
    // Cambia cuando alguien cierra o guarda algo, no cada minuto.
    staleTime: 60 * 1000,
    queryFn: () =>
      fetchToBackend<MonthlyStat[]>(
        `/organization/monthly-stats${buildQuery({
          months,
          scope: scope === "mine" ? "mine" : undefined,
        })}`,
      ),
  });
}
